var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('MediaLibrary',{attrs:{"folder-path":_vm.folderPath}})
}
var staticRenderFns = []

export { render, staticRenderFns }